<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      status: false,
    };
  },
  created() {
    this.$store.setConfig();
    this.$store.setFriendlink();
    this.$store.setIsMobile();
  },
  mounted() {
    this.status = this.$store.isMobile;
    window.addEventListener("resize", this.resizeMobile);
  },
  methods: {
    resizeMobile() {
      this.$store.setIsMobile();
      if (this.status != this.$store.isMobile) {
        window.location.reload();
      }
    },
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "SiYuan";
  src: url("http://gxbg.pangodso.com/file/SourceHanSansCN.otf");
}
* {
  margin: 0;
  padding: 0;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: "SiYuan";
  font-size: 16px;
}
::-webkit-scrollbar {
  width: 8px;
  height: 4px;
}
::-webkit-scrollbar-thumb {
  background-color: rgba($color: #000000, $alpha: 0.2);
  border-radius: 10px;
  -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-thumb:hover {
  background-color: rgba($color: #000000, $alpha: 0.4);
  -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
:hover:-webkit-scrollbar-thumb {
  background-color: rgba($color: #000000, $alpha: 0.2);
  border-radius: 10px;
  -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: transparent;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
}
::-webkit-scrollbar-track:hover {
  background-color: rgba($color: #000000, $alpha: 0.01);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.4);
}
button {
  border: 0;
  cursor: pointer;

  &:active {
    transform: scale(0.9);
  }
}
a {
  text-decoration: none;
}
.el-pagination {
  text-align: center;
}
.el-breadcrumb {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}
.rich {
  img,
  video {
    max-width: 100%;
    height: auto !important;
  }
}
</style>
